export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fashion01-mobile-de.32b8e14e.png";